import React from 'react';
import styled from 'styled-components';

const ButtonBottomDiv = styled.div`
  position: absolute;
  width: 80vw;
  display: flex;
  justify-content: center;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
`;

const ButtonGridDiv = styled.div`
  grid-area: ${(p) => p.grid};
  box-sizing: border-box;
  width: 100%;
  height: 2.5rem;
`;

const SimpleDiv = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 3rem;
  margin: ${(p) =>
    `${p.mt || '0'}rem ${p.mr || '0'}rem ${p.mb || '0'}rem ${p.ml || '0'}rem`};
  padding: ${(p) =>
    `${p.pt || '0'}rem ${p.pr || '0'}rem ${p.pb || '0'}rem ${p.pl || '0'}rem`};
`;

const StyledButton = styled.button`
  font-size: 1.1rem;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  border: ${(p) => `2px var(--color-primary) solid`};
  margin: 0;

  text-decoration: none;
  cursor: pointer;
  text-align: center;
  background-color: ${(p) => (p.filled ? 'var(--color-primary)' : 'var(--color-light)')};
  color: ${(p) => (p.filled ? 'white' : 'var(--color-primary)')};
`;

function Button({
  onClick,
  filled,
  bottom,
  grid,
  disabled,
  children,
  btnProps,
  ...rest
}) {
  if (bottom) {
    return (
      <ButtonBottomDiv {...rest}>
        <StyledButton
          onClick={onClick}
          filled={filled}
          disabled={disabled}
          {...btnProps}
        >
          {children}
        </StyledButton>
      </ButtonBottomDiv>
    );
  } else if (grid) {
    return (
      <ButtonGridDiv {...rest}>
        <StyledButton
          onClick={onClick}
          filled={filled}
          disabled={disabled}
          {...btnProps}
        >
          {children}
        </StyledButton>
      </ButtonGridDiv>
    );
  } else {
    return (
      <SimpleDiv {...rest}>
        <StyledButton
          onClick={onClick}
          filled={filled}
          disabled={disabled}
          {...btnProps}
        >
          {children}
        </StyledButton>
      </SimpleDiv>
    );
  }
}

export default Button;
